import { useEffect, useRef, useState } from 'react';

// ponytail: local worker from public/ folder (copied from node_modules at build time)
const WORKER_SRC = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

export default function PdfPreview({ url }) {
  const containerRef = useRef(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!url) return;
    let cancelled = false;

    async function render() {
      try {
        const pdfjsLib = await import('pdfjs-dist');
        pdfjsLib.GlobalWorkerOptions.workerSrc = WORKER_SRC;

        const pdf = await pdfjsLib.getDocument(url).promise;
        const totalPages = pdf.numPages;
        if (!containerRef.current || cancelled) return;
        containerRef.current.innerHTML = '';

        for (let i = 1; i <= Math.min(totalPages, 3); i++) {
          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale: 1.2 });

          const canvas = document.createElement('canvas');
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          canvas.style.width = '100%';
          canvas.style.display = 'block';

          await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;

          const wrapper = document.createElement('div');
          wrapper.style.position = 'relative';
          wrapper.style.marginBottom = '4px';
          wrapper.appendChild(canvas);

          // blur page 10+ only — pages are already locked by backend preview endpoint
          if (i > 10) {
            canvas.style.filter = 'blur(6px)';
            canvas.style.userSelect = 'none';
            canvas.style.pointerEvents = 'none';

            const overlay = document.createElement('div');
            overlay.style.cssText = `
              position:absolute;inset:0;display:flex;flex-direction:column;
              align-items:center;justify-content:center;
              background:rgba(255,255,255,0.15);
            `;
            overlay.innerHTML = `
              <div style="background:#075E54;color:#fff;padding:8px 20px;border-radius:999px;font-size:13px;font-weight:600;text-align:center;">
                🛒 Yuk, lakukan pembelian untuk dapat menikmati bacaan selengkapnya
              </div>
            `;
            wrapper.appendChild(overlay);
          }

          if (cancelled || !containerRef.current) return;
          containerRef.current.appendChild(wrapper);
        }

        if (totalPages > 3 && containerRef.current && !cancelled) {
          const fade = document.createElement('div');
          fade.style.cssText = 'height:60px;background:linear-gradient(to bottom,transparent,white);margin-top:-60px;position:relative;';
          containerRef.current.appendChild(fade);
        }
      } catch (e) {
        if (!cancelled) setError('Gagal memuat preview PDF');
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    render();
    return () => { cancelled = true; };
  }, [url]);

  if (!url) return null;

  return (
    <div className="rounded-lg overflow-hidden border border-gray-200 bg-white">
      <div className="bg-gray-50 px-3 py-1.5 flex items-center gap-2 border-b border-gray-200">
        <span className="text-xs font-medium text-gray-500">📄 Preview PDF</span>
        {loading && <span className="text-xs text-gray-400 ml-auto">Memuat...</span>}
      </div>
      {error
        ? <p className="text-xs text-red-500 p-3">{error}</p>
        : <div ref={containerRef} className="max-h-96 overflow-y-auto" />
      }
    </div>
  );
}
